import { Typography } from "@mui/material";
import React from "react";


type OrderItemInstructionProps = {
  instruction: any;
};

export default function OrderItemInstruction({
  instruction,
}: OrderItemInstructionProps) {
  return (
    <div>
      <Typography
        variant="caption">
        - Instructions : {instruction}
      </Typography>
    </div>
  );
}
